import React from 'react'

const containerStyle = {
  position: 'relative',
  display: 'inline-block',
  width: '100%',
}

const iconStyle = {
  position: 'absolute',
  top: '25px',
  right: '25px',
  width: '48px',
  height: '48px',
  opacity: 0.7,
  cursor: 'pointer',
  filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.5))',
  zIndex: 10,
  transition: 'opacity 200ms ease, transform 200ms ease',
}

export default class PlayIconOverlay extends React.Component {
  state = { hovered: false }

  render() {
    const { onClick, children } = this.props
    const currentIconStyle = {
      ...iconStyle,
      opacity: this.state.hovered ? 1 : 0.7,
      transform: this.state.hovered
        ? 'scale(1.1)'
        : 'none',
    }

    return (
      <div style={containerStyle}>
        {children}
        <svg
          viewBox="0 0 68 68"
          style={currentIconStyle}
          onMouseEnter={() => this.setState({ hovered: true })}
          onMouseLeave={() => this.setState({ hovered: false })}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onClick()
          }}
        >
          <circle cx="34" cy="34" r="33" fill="rgba(0,0,0,0.6)" stroke="white" strokeWidth="2" />
          <polygon points="26,18 26,50 52,34" fill="white" />
        </svg>
      </div>
    )
  }
}
